// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__25qEx","calendarButtons":"ClockData_calendarButtons__1_X2h"};